<template>
  <modal
    :modalid="'modal_cod_conduta'"
    :modalOpen="modalOpened"
    :profile="1"
    :form="{}"
    @close="closeModal"
  >
    <template v-slot:header> Código de Conduta </template>
    <template v-slot:main>
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left text-decoration-none"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                ÉTICA E CONDUTA COORPORATIVA
              </button>
            </h2>
          </div>

          <div
            id="collapseOne"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              Princípios Gerais<br />
              Buscamos ser referência em conduta ética, repudiando a corrupção e
              procedimentos ilegais que causem prejuízos ao Grupo Super Safra,
              às organizações e à sociedade. Todas as nossas práticas devem se
              pautar pelos princípios organizacionais, pela lei e pelas
              orientações previstas neste Manual de Conduta. Para decidir se uma
              conduta ou atividade é apropriada, avalie se:
              <br />
              <ul>
                <li>
                  Está de acordo com a legislação geral e com os normativos e
                  diretrizes específicos do Grupo Super Safra;
                </li>
                <li>
                  É capaz de beneficiar a instituição, sem causar injustiças e
                  desperdícios;
                </li>
                <li>
                  Possibilita o emprego adequado dos recursos da instituição;
                </li>
                <li>
                  Preserva e resguarda a reputação da organização;
                </li>
                <li>
                  Pode ser considerada uma ação transparente, da qual você possa
                  se orgulhar.
                </li>
              </ul>
              Reflita sobre essas questões. Se a resposta para todas elas for
              positiva, a conduta pode ser considerada adequada.
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                RESPEITAMOS OS DIREITOS HUMANOS
              </button>
            </h2>
          </div>
          <div
            id="collapseTwo"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              Respeitamos, protegemos e promovemos os direitos humanos em nossas
              atividades e relacionamentos, buscando a conscientização de todos
              a respeito do tema. Temos por missão melhorar a qualidade de vida
              das pessoas e, por compromisso, oferecer condições dignas de
              trabalho em ambientes seguros, saudáveis, respeitosos e
              inclusivos. Trabalhamos para que a nossa empresa se desenvolva de
              forma íntegra, inovadora e sustentável, o que implica promover a
              dignidade da pessoa humana, de modo a rejeitar qualquer tipo de
              discriminação; o trabalho infantil; trabalho análogo ao escravo;
              abuso e exploração sexual de crianças e adolescentes; entre outras
              situações de exclusão e vulnerabilidade.
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingThree">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                DO ASSÉDIO
              </button>
            </h2>
          </div>
          <div
            id="collapseThree"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              Diferenças de opinião e de ideias são comuns e fazem parte de
              qualquer relação humana. Um conflito saudável envolve ouvir o
              outro e respeitá-lo mesmo quando há divergências, construindo
              relações onde todas as pessoas têm espaço para se expressar sem
              ofensas. Quando as diferenças de opinião não são tratadas
              adequadamente, conflitos podem se tornar situações extremas, dando
              espaço para assédios e abusos de poder. Para promover ambientes de
              trabalho respeitosos, o GRUPO SUPER SAFRA RH não tolera
              comportamentos ofensivos, intimidadores ou hostis, que possam
              caracterizar situações de constrangimento, desrespeito, abuso de
              poder e assédio, independentemente de relação hierárquica.
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left text-decoration-none"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                ASSÉDIO ELEITORAL
              </button>
            </h2>
          </div>

          <div
            id="collapseFour"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              SOMOS TRANSPARENTES E IMPARCIAIS. Temos o compromisso de manter um
              diálogo aberto, transparente, verdadeiro e acessível com todos os
              públicos de interesse e a sociedade. O GRUPO SUPER SAFRA não
              realiza qualquer tipo de contribuição para partidos políticos ou
              candidatos a cargos eletivos, durante ou fora do processo
              eleitoral. No irrestrito respeito à lei e às pessoas, não se
              admite discriminação baseada em convicções políticas. Também não
              são tolerados, no desempenho de atividades corporativas, comporta-
              mentos que possam caracterizar qualquer forma de assédio
              eleitoral, como por exemplo, promessas para si ou para outrem,
              dinheiro, ou qualquer outra vantagem para obter ou influenciar no
              voto em determinado candidato ou partido.
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left text-decoration-none"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                ASSÉDIO RELIGIOSO
              </button>
            </h2>
          </div>

          <div
            id="collapseFive"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              O assédio religioso é um tipo de assédio moral que ocorre quando,
              no ambiente de trabalho, há constrangimento causado pela imposição
              de crença religiosa de maneira reiterada e prolongada. Este tipo
              de assédio fere a liberdade de crença prevista na Constituição
              Brasileira.
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left text-decoration-none"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                ASSÉDIO SEXUAL
              </button>
            </h2>
          </div>

          <div
            id="collapseSix"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              Previsto no Código Penal Brasileiro como crime, situações de
              assédio sexual ocorrem por atos, insinuações, contatos físicos
              forçados e convites impertinentes com o intuito de obter vantagem
              ou favorecimento sexual, prevalecendo-se o agente de sua condição
              de superior hierárquico ou ascendência inerentes ao exercício do
              emprego, cargo ou função. Para que seja identificada a prática do
              assédio sexual, não há necessidade de contato físico entre os
              envolvidos. Ainda que a situação não configure legalmente a
              hipótese de assédio sexual, a conduta inadequada pode caracterizar
              desrespeito grave, constrangimento ilegal e, até mesmo, crime de
              estupro. Por isso, o relacionamento deve ser respeitoso em
              qualquer tipo de relação profissional, seja de clientes,
              fornecedores, colaboradores, gestores, entre outros,
              independentemente da relação hierárquica.
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left text-decoration-none"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                ABUSO DE PODER
              </button>
            </h2>
          </div>

          <div
            id="collapseSeven"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              É configurado pelo uso de poder de forma ilegal, coercitiva ou em
              desacordo com suas finalidades. Em outras palavras, abusa do poder
              aquele que usa de seus direitos de forma ilimitada, em prejuízo
              dos demais. O abuso de poder pode ocorrer nas relações internas,
              em situações decorrentes da subordinação afeta à relação de
              emprego, como também externamente, nas relações com fornecedores,
              parceiros, entre outros.
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button
                class="btn btn-link btn-block text-left text-decoration-none"
                type="button"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                DENÚNCIAS
              </button>
            </h2>
          </div>

          <div
            id="collapseEight"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body text-justify">
              Eventuais situações de assédio devem ser devidamente reportadas ao
              seu Gestor direto e/ou Departamento de RH da empresa. O
              departamento de RH do Grupo Super Safra apreciará seu relato ou
              questionamento e com fundamento nesta política e em legislação
              específica pertinente à sua mensagem, levará o tema para análise
              dos responsáveis. Caso a denúncia ou dúvida não atenda aos
              requisitos legais ou dos códigos e políticas da empresa, sendo,
              portanto, desprovida de embasamento, será arquivada, com a devida
              informação ao remetente.
            </div>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import ModalComponent from "../ModalComponent.vue";
export default {
  data() {
    return {
      modalOpened: false,
    };
  },
  props: {
    openThis: {
      required: true,
    },
  },
  methods: {
    openModal() {
      this.modalOpened = true;
    },
    closeModal() {
      this.modalOpened = false;
    },
  },
  watch: {
    openThis: function () {
      this.openModal();
    },
  },
  components: {
    modal: ModalComponent,
  },
};
</script>
